/**
 * 集中化的權限判斷邏輯
 * 統一管理 admin 白名單、trial 帳號判斷、permission flag 檢查
 */

/** 向後兼容：admin 帳號白名單（無 permissions_json 時的回退邏輯） */
const LEGACY_ADMIN_EMAILS = [
  'admin@legalcontract.com',
  'admin_legalstaff@legalcontract.com',
  'admin_manager@legalcontract.com',
  'admin_business@legalcontract.com',
  'admin@hotaimotor.com.tw',
  'admin@legalsign.ai',
];

/** 向後兼容：trial 帳號 domain（無 permissions_json 時的回退邏輯） */
const LEGACY_TRIAL_DOMAINS = ['@legalcontract.com', '@demo.com'];

interface UserWithPermissions {
  email: string;
  permissions?: Record<string, boolean>;
}

/**
 * 檢查使用者是否為 legacy admin（email 白名單）
 */
export function isLegacyAdmin(email: string): boolean {
  return LEGACY_ADMIN_EMAILS.includes(email);
}

/**
 * 檢查使用者是否為 trial 帳號
 */
export function isTrialAccount(email: string): boolean {
  return LEGACY_TRIAL_DOMAINS.some(domain => email.includes(domain));
}

/**
 * 統一的權限檢查邏輯：
 * 1. 優先使用 permissions_json（新權限系統）
 * 2. 回退：admin email 白名單
 * 3. 回退：trial 帳號 domain
 */
export function hasPermission(
  user: UserWithPermissions | null | undefined,
  permission: string
): boolean {
  if (!user) return false;

  // 優先使用新權限系統
  if (user.permissions && Object.keys(user.permissions).length > 0) {
    const value = user.permissions[permission];
    if (value !== undefined) return value === true;
  }

  // 回退：admin 白名單
  if (isLegacyAdmin(user.email)) return true;

  // 回退：trial 帳號
  if (isTrialAccount(user.email)) return true;

  return false;
}
